import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UpgradeModule } from '@angular/upgrade/static';
import { AccountsDomainModule } from '@mode/accounts/domain';
import { ChartsDomainModule } from '@mode/charts/domain';
import { CollectionsFeatureManageAccessModule } from '@mode/collections/feature-manage-access';
import { PdfExportDomainModule } from '@mode/report-viewer/pdf-export/domain';
import { ReportViewerShellModule } from '@mode/report-viewer/shell';
import { ReportsDomainModule } from '@mode/reports/domain';
import { SharedDataAccessFlamingoModule } from '@mode/shared/data-access-flamingo';
import { SharedDataAccessWebappModule } from '@mode/shared/data-access-webapp';
import { EmptyComponent } from '@mode/shared/ui';
import { SharedUtilDomModule } from '@mode/shared/util-js';
import { SwitchViewsFeatureFieldlistModule } from '@mode/switch-views/feature-fieldlist';
import { LegacyBootstrapService, mark } from '~/legacy-bootstrap.service';
import { LEGACY_PROVIDERS } from '~/lib/legacy-providers';

// Legacy features
import { LEGACY_STORES } from '~/lib/legacy-reducers';

import { DatasetDomainModule } from '@mode/dataset/domain';
import { GithubFeatureSyncModalModule } from '@mode/github/feature-sync-modal';
import { PlatformHeaderNavPanelComponentModule } from '~/components/platform-header-nav-panel/platform-header-nav-panel-component.module';
import { loadAngularJsMainAppShell } from '.';
import { PublishModule } from '@mode/dataset/feature-publish';

const enableRouterTracing = false;

/**
 * If you want to enable ui-router tracing.
 * Importing trace will add ui-router to the bundle.
 * So it is commented out by default.
 */
// import { trace } from '@uirouter/core';
// trace.enable();

@NgModule({
  imports: [
    CommonModule,
    ChartsDomainModule,
    SharedDataAccessFlamingoModule,
    SharedDataAccessWebappModule,
    SharedUtilDomModule,
    UpgradeModule,
    ReportViewerShellModule,
    ReportsDomainModule,
    PdfExportDomainModule,
    AccountsDomainModule,
    DatasetDomainModule,
    ReactiveFormsModule,
    SwitchViewsFeatureFieldlistModule,
    CollectionsFeatureManageAccessModule,
    GithubFeatureSyncModalModule,
    PlatformHeaderNavPanelComponentModule,
    PublishModule,
    RouterModule.forChild([
      {
        path: '**',
        component: EmptyComponent,
      },
    ]),
    ...LEGACY_STORES,
  ],
  providers: [...LEGACY_PROVIDERS],
})
export class MainShellModule {
  constructor(private upgrade: UpgradeModule, private legacy: LegacyBootstrapService, private injector: Injector) {
    this.legacy.bootstrap(loadAngularJsApp, this.upgrade, this.injector);
  }
}

async function loadAngularJsApp() {
  mark('mode.main.js', 'mode.webapp_ui.resource.js.mode.main');
  loadAngularJsMainAppShell();
}
